import React, { Component } from 'react'
import { Link, withRouter } from 'react-router-dom';

class privateScreeningSidebar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isACtive: false,
            routeArray: [
                { routeName: 'Profile', linkTo: '/partners-profile', compare: ['partners-profile'] },
                { routeName: 'Films', linkTo: '/partners-film-view', compare: ["partners-film-view", "partner-film-detail-view", "create-private-film", "edit-private-film"] },
                { routeName: 'Screenings', linkTo: "/partner-screening-list", compare: ["partner-screening-list", "partner-add-screening", "partner-edit-screening"] },
                { routeName: 'User Activities', linkTo: '/partner-user-activities',compare:['partner-user-activities'] }

            ]
        };

        // This binding is necessary to make `this` work in the callback
        this.navClick = this.navClick.bind(this);
    }

    navClick() {
        if (this.props.refresh) {
            this.props.refresh()
        }
    }

    render() {
        var currPath = this.props.router.pathname;
        if (currPath === '/partners-list') {
            this.props.history.push('/partners-film-view');
        }
        return (
            <div className="left_side_wrapper">
                <ul>
                    {this.state.routeArray.map((item) => {
                        var isActive = false
                        item.compare.map(path => {
                            var isdata = currPath.includes(path);
                            if (isdata) { isActive = true; return }
                        })
                        return (
                            <li>
                                <Link onClick={() => this.navClick()}
                                    to={item.linkTo}
                                    className={isActive ? 'active' : ''}>{item.routeName}</Link>
                            </li>
                        )
                    })}
                </ul>

            </div>
        )
    }
}
export default withRouter(privateScreeningSidebar)
